const managePayment = {
  managePayment: {
    pageTitle: 'Manage Payment',
    description: 'Search and manage all payment history, and handle refund requests.',
    tabs: {
      pending: 'PENDING',
      complete: 'COMPLETE',
      failed: 'FAILED',
      refunded: 'REFUNDED'
    },
    filters: {
      paymentMethod: 'Payment Method',
      search: 'Search'
    },
    buttons: {
      search: 'Search',
      reset: 'Reset',
      refund: 'Refund',
      refunded: 'Refunded',
      processing: 'Processing...',
      close: 'Close',
      forceComplete: 'COMPLETED'
    },
    loadingText: 'Loading data...',
    refundModal: {
      title: 'Confirm Refund',
      body: 'Are you sure you want to refund this order?\nOrder ID: {{orderId}}\nThis operation cannot be undone.'
    },
    alerts: {
      loadFailed: 'Failed to load payment data. Please try again.',
      statusUpdateFailed: 'Failed to update status.',
      refundFailed: 'Failed to process refund.'
    }
  }
};

export default managePayment;